<template>
  <div class="page page-profile">
    <!-- 用户信息区域 -->
    <div class="user-info">
      <div class="user-avatar-section">
        <div class="avatar">
          <span class="avatar-text">{{usernameAvatar}}</span>
        </div>
      </div>
      <div class="username">
        {{username}}
        <div class="member-badge">早鹰会员</div>
      </div>
    </div>

    <!-- 电影余额卡片 -->
    <!-- <div class="balance-card">
      <div class="balance-left">
        <div class="balance-title">电影余额</div>
      </div>
      <div class="balance-right">
        <div class="balance-count">8场</div>
        <div class="balance-subtitle">剩余场次</div>
      </div>
    </div>-->

    <!-- 我的订单区域 -->
    <div class="orders-section">
      <div class="section-title">我的信息</div>
      <div class="order-item" @click="goToMembershipCards">
        <div class="order-icon el-icon-bank-card"></div>
        <div class="order-text">会员卡</div>
        <div class="order-arrow el-icon-arrow-right"></div>
      </div>      <div class="order-item" @click="goToMoviegoers">
        <div class="order-icon el-icon-user"></div>
        <div class="order-text">观影人</div>
        <div class="order-arrow el-icon-arrow-right"></div>
      </div>
      <div class="order-item" @click="goToOrders">
        <div class="order-icon el-icon-s-order"></div>
        <div class="order-text">预约记录</div>
        <div class="order-arrow el-icon-arrow-right"></div>
      </div>
      <!-- <div class="order-item" @click="goToPaymentRecords">
        <div class="order-icon el-icon-tickets"></div>
        <div class="order-text">支付记录</div>
        <div class="order-arrow el-icon-arrow-right"></div>
      </div> -->
    </div>

    <!-- 退出登录 -->
    <!-- <div class="logout-section">
      <button class="logout-btn" @click="handleLogout">退出登录</button>
    </div> -->
  </div>
</template>

<script>
import api from "@/utils/api";
export default {
  name: "ProfileMain",
  data() {
    return {
      username: localStorage.getItem("username"),
      usernameAvatar: localStorage.getItem("username").substring(0, 1)
    };
  },
  created(){
  },
  methods: {
    async handleLogout() {
      try {
        await api.LogOut().then(() => {
          this.$router.replace("/");
          localStorage.removeItem("remembered_Token");
          localStorage.removeItem("username");
          localStorage.removeItem("movieShowtimes");
        });
      } catch (error) {
        console.error("退出失败:", error);
        this.$message && this.$message.error("退出失败");
      }
    },
    goToMembershipCards() {
      this.$router.push({ name: "membershipCards" });
    },
    goToOrders() {
      this.$router.push({ name: "appointmentRecords" });
    },
    goToMoviegoers() {
      this.$router.push({ name: "moviegoers" });
    },
    goToPaymentRecords() {
      this.$router.push({ name: "paymentRecords" });
    }
  }
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  background: linear-gradient(
    135deg,
    rgba(195, 77, 52, 0.28) 0%,
    rgba(248, 248, 248, 0.08) 100%
  );
  padding: 0;
}

/* 状态栏 */
.status-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
}

.time {
  color: #000000;
}

.status-icons {
  display: flex;
  gap: 4px;
  color: #000000;
}

/* 用户信息区域 */
.user-info {
  display: flex;
  align-items: flex-start;
  padding: 20px 16px;
}

.user-avatar-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 16px;
}

.avatar {
  width: 60px;
  height: 60px;
  line-height: 60px;
  border-radius: 50%;
  background: #ff6b6b;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
}

.avatar-text {
  color: #ffffff;
  font-size: 24px;
  font-weight: 600;
}

.member-badge {
  display: block;
  background: #154d91;
  color: #ffffff;
  padding: 1px 2px;
  border-radius: 12px;
  font-size: 10px;
  text-align: center;
  font-weight: 500;
  white-space: nowrap;
  box-shadow: 0 1px 4px rgba(255, 107, 107, 0.3);
  width: fit-content;
  margin-top: 4px;
}

.username {
  width: auto;
  font-size: 18px;
  font-weight: 600;
  color: #000000;
  margin-top: 8px;
}

/* 电影余额卡片 */
.balance-card {
  background: #c34821;
  margin: 0 16px 20px 16px;
  padding: 20px;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
}

.balance-left {
  color: #ffffff;
}

.balance-title {
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
}

.balance-right {
  text-align: right;
  color: #ffffff;
}

.balance-count {
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1;
}

.balance-subtitle {
  font-size: 12px;
  color: #ffffff;
  margin-top: 4px;
}

/* 我的订单区域 */
.orders-section {
  padding: 0 16px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #000000;
  margin-bottom: 16px;
}

.order-item {
  display: flex;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s;
}

.order-icon {
  font-size: 25px;
  margin-right: 12px;
  color: #ff6b6b;
}

.order-text {
  flex: 1;
  font-size: 16px;
  color: #000000;
}

.order-arrow {
  font-size: 16px;
  color: #999999;
}

/* 退出登录 */
.logout-section {
  padding: 20px 16px;
}

.logout-btn {
  width: 100%;
  padding: 12px;
  background: #c34d34;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.logout-btn:hover {
  background: #c34d34;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .page {
    padding-bottom: 80px; /* 为底部导航栏留出空间 */
  }

  .user-info {
    padding: 16px;
  }

  .balance-card {
    margin: 0 16px 16px 16px;
    padding: 16px;
  }

  .orders-section {
    padding: 0 16px;
  }

  .logout-section {
    padding: 16px;
  }
}
</style>


